import React from "react";
import { Info } from "./Info";

export const RevenueCategoryRow = ({
  item,
  onShowAllClick,
  handleCategory,
  canEnableChallengers,
  handlePopup,
  referralId,
  canToggleTags,
  showAllItems,
  setShowAllItems,
  measure
}) => {
  const { id, name, count, challenger, type } = item;

  if (type === "header") {
    return <p className="revenue-categories__title">{item.title}</p>;
  }

  return (
    <>
      <li color="dark" className="group__item" onClick={() => handleCategory(id)}>
        <div className="group__el text">
          {name} ({count} assigned)
        </div>
        {canEnableChallengers && (
          <div
            className="group__el challenger"
            onClick={(e) => {
              e.stopPropagation();
              handlePopup(item, "challengers");
            }}
          >
            <span
              title={`${challenger ? "Disable" : "Enable"} Challengers Option`}
              className={`glyphicon glyphicon-copyright-mark ${challenger ? "text-green" : "grey"}`}
            />
          </div>
        )}
        {canToggleTags && (
          <div className="group__el showAll" onClick={(e) => onShowAllClick(e, id === referralId)}>
            <span
              className={`glyphicon glyphicon-tags ${
                showAllItems && id === referralId ? "text-green" : "grey"
              } `}
            />
          </div>
        )}
      </li>
      {id === referralId ? (
        <Info
          revenueCategoryId={id}
          showAllItems={showAllItems}
          canToggleTags={canToggleTags}
          setShowAllItems={setShowAllItems}
          measure={measure}
        />
      ) : null}
    </>
  );
};
